// init
// import menu from './init/menu.js';

// loading
import { setCookie, getCookie } from './components/cookies.js';

// components
// import customCursor from "./components/cursor.js";
import smoothScroll from "./components/smoothScroll.js";
import menu from "./components/menu.js";
import footer from "./components/footer.js";
import blockPin from "./components/blockPin.js";

import animateMedia from "./components/animateMedia.js";
import animateTitle from "./components/animateTitle.js";
import animateContent from "./components/animateContent.js";
import countUp from "./components/countUp.js";

import './components/button.js';

// blocks
import galleryCursor from './blocks/galleryCursor.js';
import banner from './blocks/banner.js';
import bannerMosaico from './blocks/bannerMosaico.js';
import carouselFull from './blocks/carouselFull.js';
import scrollHorizontal from './blocks/scrollHorizontal.js';
import lightgalleryVideo from './components/lightgalleryVideo.js';
import lightgalleryImages from './components/lightgalleryImages.js';
import gallerySteps from './blocks/gallerySteps.js';
import galleryVertical from './blocks/galleryVertical.js';
import galleryCarousel from './blocks/galleryCarousel.js';
import galleryCarouselText from './blocks/galleryCarouselText.js';
import Masterplan from './blocks/masterplan.js';
import map from './blocks/map.js';
import carouselCardsIcon from './blocks/carouselCardsIcon.js';
import carouselFeatures from './blocks/carouselFeatures.js';
import contactForm from './blocks/form.js';
import tabsMedia from './blocks/tabsMedia.js';
import pinnedList from './blocks/pinnedList.js';

// Helper function to conditionally initialize modules
const initIfExists = (selector, callback) => {
    if (document.querySelector(selector)) {
        callback();
    }
};

///////////////////////////////////////////////////////////////////////////////////

// before loaded
document.addEventListener('DOMContentLoaded', dcl);

// load
window.addEventListener('load', () => {

    const loader = document.querySelector('.loading');
    const html = document.documentElement;

    // smooth scroll
    smoothScroll();

    // Inicializar loading con video o imagen
    let hideDelay, removeDelay;

    if (!getCookie('visited')) {
        // Primera visita: mostrar video
        initLoadingVideo(loader);
        setCookie('visited', '1', 30); // 30 días
        hideDelay = 3000;
        removeDelay = 3500;
    } else {
        // Visitas siguientes: mostrar imagen
        initLoadingImage(loader);
        hideDelay = 500;
        removeDelay = 1000;
    }

    // Después de que el video termine (5 segundos)
    setTimeout(() => {

        loader.classList.add('hidden');

        // Reanudar smooth scroll si existe
        if (window.gsapSmoother) {
            window.gsapSmoother.paused(false);
        }

        // Habilitar scroll en HTML
        html.classList.remove('loading-active');
        window.removeEventListener('wheel', window.disableScroll);
        window.removeEventListener('touchmove', window.disableScroll);

    }, hideDelay);

    setTimeout(() => {
        loader.style.display = 'none';
        load();
    }, removeDelay);

});

// Window On Resize
window.addEventListener('resize', onResize);

// ///////////////////////////////////////////////////////////////////////////////////

function initLoadingVideo(loader) {
    if (!loader) return;

    const videoUrl = loader.getAttribute('data-video');
    if (!videoUrl) return;

    // Añadir clase para video
    loader.classList.add('loading--video');

    // Crear y añadir el elemento video
    const video = document.createElement('video');
    video.autoplay = true;
    video.muted = true;
    video.playsInline = true;
    video.loop = false;

    const source = document.createElement('source');
    source.src = videoUrl;
    source.type = 'video/mp4';

    video.appendChild(source);
    loader.appendChild(video);
}

function initLoadingImage(loader) {

    if (!loader) return;

    const imageUrl = loader.getAttribute('data-brand');
    if (!imageUrl) return;

    // Añadir clase para imagen
    loader.classList.add('loading--image');

    // Crear y añadir el elemento imagen
    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = 'Loading';

    loader.appendChild(img);
}

function dcl() {

    // initIfExists("splide--fullscreen", splideFullscreen);
    // changeBG();

    // console.log('DOM fully loaded and parsed');
    initIfExists(".header__burger", menu);

}

function load() {

    // lightGallery debe inicializarse cuando ScrollSmoother ya está creado.
    initIfExists(".video__trigger", lightgalleryVideo);
    initIfExists(".lightgallery__images", lightgalleryImages);

    // IMPORTANTE: animateMedia ANTES de smoothScroll para calcular alturas primero
    initIfExists(".animate__media", animateMedia);

    // general animations
    // IMPORTANTE: blockPin DESPUÉS de animateTitle/animateContent. Su
    // spacer de "pausa de lectura" se recalcula en el mismo evento
    // 'refreshInit' de ScrollTrigger, y los listeners se ejecutan en el
    // orden en que se registran; si blockPin midiera el bloque siguiente
    // antes de que su texto se haya vuelto a partir tras un resize,
    // usaría una altura desactualizada y dejaría un hueco visible.
    initIfExists(".animate__title", animateTitle);
    initIfExists(".animate__content", animateContent);
    initIfExists("[data-pin-block]", blockPin);
    initIfExists("[data-countup]", countUp);

    // blocks   
    initIfExists(".banner", banner);
    initIfExists(".banner-mosaic", bannerMosaico);
    initIfExists(".carousel-full", carouselFull);
    initIfExists(".scroll-horizontal", scrollHorizontal);
    initIfExists(".scroll_horizontal_02", scrollHorizontal);
    initIfExists(".gallery-steps", gallerySteps);
    initIfExists(".gallery-vertical", galleryVertical);
    initIfExists("#map", map);
    initIfExists(".carousel-cards-icon", carouselCardsIcon);
    initIfExists(".carousel-features__images", carouselFeatures);
    initIfExists(".site__footer", footer);
    initIfExists(".gallery-carousel", galleryCarousel);
    initIfExists(".gallery_carousel_with_texts", galleryCarouselText);
    initIfExists(".tabs-media", tabsMedia);
    initIfExists(".pinned-list", pinnedList);
    initIfExists(".wpcf7", contactForm);

    if (document.querySelector(".masterplan")) {
        new Masterplan();
    }

    initIfExists(".gallery-cursor", () => galleryCursor({
        minWidth: 992,
        moveDistance: 15,
        stopDuration: 350,
        trailLength: 8
    }));

    customCursor();

}

function onResize() {
    // initIfExists(".animate__title", animateTitle);
    // initIfExists(".animate__content", animateContent);
}